export default class DtoMessage {
    constructor(object) {
        this.login = object.login
        this.idmessage = object.idmessage
        this.message = object.message
        this.idcms = object.idcms
        this.updateLogin = object.updateLogin
        this.updateDate = object.updateDate
    }
}